/**
 * AsteriskIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const AsteriskIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10.9 20.35v-6.425L5.325 17.15l-1.1-1.925L9.8 12 4.225 8.8l1.1-1.925L10.9 10.1V3.65h2.2v6.45l5.575-3.225 1.1 1.925L14.2 12l5.575 3.225-1.1 1.925-5.575-3.225v6.425z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const AsteriskIcon = makeIcon('AsteriskIcon', AsteriskIconSvg)
